import { Component, OnInit } from '@angular/core';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';

@Component({
  selector: 'app-legal-requirements',
  templateUrl: './legal-requirements.component.html',
  styleUrls: ['./legal-requirements.component.scss'],
})
export class LegalRequirementsComponent implements OnInit {
  legal: any;

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private parametersService: ParametersService,
    private navigationService: NavigationService,
  ) {
    this.headerService.show(false, false, true);
  }

  ngOnInit() {
    this.legal = this.parametersService.getSetting(OpEnum.LEGAL_REQUIREMENTS);
  }

  next() {
    this.navigationService.nextStep('201');
  }

  previous() {
    this.navigationService.previousStep();
  }
}
